export default {
    label_task:{
        en:"Dealers Sales Return",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Dealer Sales",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Dealer Sales Return",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Dealer Sales Return",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_sales_return_at:{
        en:"Sales Retun Entry Time",
        bn:"কর্মচারী আইডি"
    },

}